import { Outlet, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Header } from "../components/Header/Header";
import { Footer } from "../components/Footer/Footer";

import "./AuthLayout.style.css";

export const AuthLayout = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="auth-page">

      <Header />

      <button
        className="back-btn"
        onClick={() => navigate(-1)}
        aria-label={t('previous')}
      >
        ←
      </button>

      <main className="auth-content">
        <Outlet />
      </main>

      <Footer />

    </div>
  );
};